import {Action} from 'redux'
import {LedgerModel} from '../Model/Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface IAuditTrailState {
  data?: {
    ledger?: LedgerModel[]
    meta?: {[key: string]: string | number}[]
  }
  filterOptions?: {
    actors?: {id: string; name: string}[]
    models?: {value: string; label: string}[]
  }
  loading?: boolean
  success?: boolean
}

const initialAuditTrailState: IAuditTrailState = {
  data: {
    ledger: [],
    meta: [],
  },
  filterOptions: {
    actors: [],
    models: [],
  },
  loading: false,
  success: false,
}

export const reducer = (
  state: IAuditTrailState = initialAuditTrailState,
  action: ActionWithPayload<IAuditTrailState>
) => {
  switch (action.type) {
    case actionTypes.GET_AUDIT_TRAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_AUDIT_TRAIL_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_AUDIT_TRAIL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.GET_AUDIT_TRAIL_FILTER_OPTIONS_SUCCESS: {
      return {...state, filterOptions: action.payload}
    }

    case actionTypes.GET_AUDIT_TRAIL_FILTER_OPTIONS_FINISH: {
      return state
    }

    default:
      return state
  }
}
